import { render } from "./Invoices.vue?vue&type=template&id=5f14162b&scoped=true&ts=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=5f14162b&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f14162b"]])

export default __exports__